module.exports = __webpack_public_path__ + "img/404-dark.1e44c9f2.png";